import React from 'react';

const Avatar = ({ profilePicture = null, userName, size = 48 }) => {
  const initial = userName ? userName.charAt(0).toUpperCase() : 'U';
  const dimensionClass = `w-${size / 4} h-${size / 4}`; 

  return (
    <div
      className={`${dimensionClass} bg-profile rounded-full flex w-full h-[100%] items-center justify-center text-white-text text-level-4 font-alexandria font-bold overflow-hidden`}
    >
      {profilePicture ? (
        <img
          src={profilePicture}
          alt={userName}
          className="w-full h-[100%] object-cover"
        />
      ) : (
        <span>{initial}</span>
      )}
    </div>
  );
};

export default Avatar;